const checkModalTaskValidation = (data) => {
    const {
        img,
        link,
        modal_data,
    } = data;
    let errors = {};
    const linkRegex = /^https?:\/\/([a-z0-9-]+\.)+[a-z]{2,}(:[0-9]{1,5})?(\/[^\s]*)?$/i;

    return new Promise((value) => {
        if (modal_data?.is_img_required) {
            if (!img) {
                errors['img'] = 'Image is required'
            }
        }

        if (modal_data?.is_link_required) {
            if (link.length < 1) {
                errors['link'] = 'Link is required'
            } else if (!linkRegex.test(link)) {
                errors['link'] = 'Link is not valid'
            }
        }

        value(errors);
    });
};

export default checkModalTaskValidation;
